__webpack_require__.p = "https://public.instacover.ai/assets/portal/_next/";